import styled from "styled-components";

const FileNameStyled = styled.td`
  position: relative;
`;

export default FileNameStyled;
